exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-form-item-location__map {\n  width: 100%;\n  height: 480px;\n}\n.v-form-item-location__map--loading {\n  text-align: center;\n  line-height: 480px;\n  border-radius: 4px;\n}\n.v-form-item-location .has-feedback .ant-form-item-children-icon {\n  width: auto;\n  right: -5px;\n}\n", ""]);

// exports
